import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'
import { HttpMethod } from '../../../services/core'

const resource = 'templates'
const verb = HttpMethod.DELETE

export default class OspreyTemplatesRemoveFromSilosShare extends BaseAction {
    constructor(dataKey) {
        const id = '558621b8-9c6d-442c-8291-e6d3a2565776'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    removeFromSilosShare(params) {
        const { templateId, siloIdList } = params

        this.path = `/${resource}/${templateId}/share/silos`

        this.params = {
            siloIdList
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/templates/templates-silos-remove.js